import gql from 'graphql-tag'

export default gql`
  query fetchExternalRedInvoice($taxCode: String!) {
    fetchExternalRedInvoice(taxCode: $taxCode) {
      data {
        name
        address
      }
      error
    }
  }
`
